import styled from "styled-components";

export const FilterV2Styles = styled.div`
   display: flex;
   margin-bottom: 28px;
   margin-top: 16px;
`